import React from "react";
// import img1 from "../image/project1.png";
// import img2 from "../image/project2.png";
import img1 from "../image/featured-project-gallery/project-gallery-18.png";
import img2 from "../image/gallary-img1.png";
// import img3 from "../image/project3.png";
import img3 from "../image/featured-project-gallery/project-gallery-03.jpeg";
// import img4 from "../image/project4.png";
import img4 from "../image/architecture-projects/ved-estate-01.png";
import img5 from "../image/project5.png";
// import img6 from "../image/project6.png";
import img6 from "../image/gallary444.png";
import img7 from "../image/project7.png";

const rows = [
  {
    id: "row-1",
    direction: "ltr",
    rowClass: "proj-row-large",
    items: [
      {
        id: 7,
        img: img7,
        size: "large",
        title: "Modern Bungalow Design",
        type: "Architecture + Construction",
        location: "Pune",
      },
      {
        id: 2,
        img: img2,
        size: "large",
        title: "Airport Theme commercial space",
        type: "Exterior Design",
        location: "Maharashtra",
      },
    ],
  },
  {
    id: "row-2",
    direction: "rtl",
    rowClass: "proj-row-small",
    items: [
      {
        id: 3,
        img: img3,
        size: "small",
        title: "Contemporary Home Interior",
        type: "Residential Design",
        location: "Pune",
      },
      {
        id: 4,
        img: img4,
        size: "small",
        title: "Commercial space design",
        type: "Commercial Design",
        location: "PCMC",
      },
      {
        id: 5,
        img: img5,
        size: "small",
        title: "Smart Space Planning",
        type: "Design Consultancy",
        location: "Maharashtra",
      },
    ],
  },
  {
    id: "row-3",
    direction: "ltr",
    rowClass: "proj-row-wide",
    items: [
      {
        id: 6,
        img: img6,
        size: "wide",
        title: "Luxury Residence Build",
        type: "Residential Apartment ",
        location: "Pune",
      },
      {
        id: 1,
        img: img1,
        size: "wide",
        title: "Modern Facade Concept",
        type: "Architecture Design",
        location: "Maharashtra",
      },
    ],
  },
];

const renderCard = (item, copyIndex) => (
  <div key={`${item.id}-${copyIndex}`} className={`proj-card ${item.size}`}>
    <img src={item.img} alt={item.title} />

    <div className="proj-overlay">
      <div>
        <span>{item.type}</span>
        <h3>{item.title}</h3>
        <p>{item.location}</p>
      </div>
    </div>
  </div>
);

export default function ImgGrid() {
  return (
    <div className="proj-grid">
      {rows.map((row) => (
        <div
          key={row.id}
          className={`proj-marquee-row ${row.rowClass} proj-row-${row.direction}`}
        >
          <div className="proj-marquee-track">
            {[0, 1].map((copyIndex) => (
              <React.Fragment key={`${row.id}-${copyIndex}`}>
                {row.items.map((item) => renderCard(item, copyIndex))}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
